import qs from 'qs';
import _ from 'underscore';
import AdminServerActionCreators from '../actions/AdminServerActionCreators';
import AdminConstants from '../constants/AdminConstants';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import client from './rest/AdminClient';

const Actions = AdminConstants.ActionTypes;

const availableDriversQuery = {
  select: 'first_name last_name carrier coords',
  populate: [
    {
      path: 'carrier',
      select: 'first_name last_name email phone name picture',
    },
  ],
  available: true,
};

const getDriverWaypoints = (id, start, end) => {
  const query = qs.stringify({
    start,
    end,
  });

  return client({
    method: 'GET',
    path: `/api/audits/drivers/${id}/waypoints?${query}`,
  });
};

const nearbyDriversQuery = {
  select:
    'first_name last_name phone pending_offers carrier equipment_class coords jobs available has_active_jobs',
  populate: [
    {
      path: 'carrier',
      select: 'name authorized',
    },
  ],
  paginate: true,
  available: true,
  authorized: true,
  carrier_authorized: true,
  per_page: 200,
};

const getAuthorizedDriversQuery = {
  select:
    'first_name last_name carrier coords username available equipment_class',
  populate: [
    {
      path: 'carrier',
      select: 'first_name last_name email phone name picture authorized',
    },
  ],
  authorized: false,
  per_page: 20,
  paginate: true,
};

const getAvailableDriversByMarketQuery = {
  select: '_id first_name last_name carrier',
  populate: [
    {
      path: 'carrier',
      select: 'name',
    },
  ],
  authorized: true,
  per_page: 500,
  available: true,
};

const getDriverNamesByCarrierQuery = {
  select: '_id first_name last_name username documents picture',
  populate: [
    {
      path: 'carrier',
      select: 'name',
    },
  ],
  authorized: true,
  per_page: 20,
};

function getDriverManifests(id) {
  return client({
    method: 'GET',
    path: `/api/1/drivers/${id}/manifests`,
  });
}

function departManifest(manifest) {
  return client({
    method: 'POST',
    path: `/api/v2/jobs/bulk/pickup/complete`,
    entity: JSON.stringify(manifest),
  });
}

function getAuthorizedDrivers(params = {}, options = {}) {
  const query = _.extend(getAuthorizedDriversQuery, params, options);
  const queryString = qs.stringify(query);
  return client({
    method: 'GET',
    path: `/admin/api/v2/drivers?${queryString}`,
  });
}

function getAvailableDrivers(params = {}, options = {}) {
  console.log('getting available drivers');
  const query = _.extend(availableDriversQuery, params, options);
  const queryString = qs.stringify(query);
  return client({
    method: 'GET',
    path: `/admin/api/v2/drivers?${queryString}`,
  });
}

function getNearbyDrivers(params = {}, options = {}) {
  const query = _.extend(nearbyDriversQuery, params, options);
  const queryString = qs.stringify(query);

  return client({
    method: 'GET',
    path: `/admin/api/v2/drivers?${queryString}`,
  });
}

export function acceptOffer({ offerId, driverId }) {
  return client({
    method: 'PUT',
    path: '/api/1/offers/accept',
    entity: JSON.stringify({
      offer_id: offerId,
      driver_id: driverId,
      accept: true,
      by_proxy: true,
    }),
  });
}

const getDriverNamesByCarrier = async (carrierId, near = []) => {
  const queryString = qs.stringify({
    carriers: [carrierId],
    ...getDriverNamesByCarrierQuery,
    near,
  });
  return client({
    method: 'GET',
    path: `/admin/api/v2/drivers?${queryString}`,
  });
};

function getAvailableDriversByMarket(params = {}, options = {}) {
  const query = _.extend(getAvailableDriversByMarketQuery, params, options);
  const queryString = qs.stringify(query);

  return client({
    method: 'GET',
    path: `/admin/api/v2/drivers?${queryString}`,
  });
}

const Utils = {
  getDriverManifests(id) {
    getDriverManifests(id).then(
      (response) => {
        AdminServerActionCreators.receiveDriverManifest(
          response.entity.manifests,
        );
      },
      (response) => {
        console.error(response);
      },
    );
  },
  departManifest(doc) {
    departManifest(doc).then(
      (response) => {
        AdminServerActionCreators.receiveDepartedManifest(
          response.entity.manifest,
        );
      },
      (response) => {
        console.error(response);
      },
    );
  },
  getAuthorizedDrivers() {
    getAuthorizedDrivers().then(
      (response) => {
        AdminServerActionCreators.receiveAuthorizedDriversSuccess(
          response.entity.data,
        );
      },
      (response) => {
        console.error(response);
      },
    );
  },
  getAvailableDrivers() {
    getAvailableDrivers().then(
      (response) => {
        AdminServerActionCreators.receiveAvailableDriversSuccess(
          response.entity.data,
        );
      },
      (response) => {
        console.error(response);
      },
    );
  },
  getDriverWaypoints(id, start, end) {
    getDriverWaypoints(id, start, end).then(
      (response) => {
        AdminServerActionCreators.receiveDriverWaypointsSuccess(
          response.entity,
        );
      },
      (response) => {
        console.log('Failed to get driver waypoints', response);
      },
    );
  },
  getNearbyDrivers(query) {
    getNearbyDrivers(query).then(
      (response) => {
        AdminServerActionCreators.receiveNearbyDriversSuccess(
          response.entity.data,
          response.entity.meta.count,
        );
      },
      (response) => {
        console.error(response);
      },
    );
  },
  acceptOffer(props) {
    acceptOffer(props).then(
      (response) => {
        const {
          entity: { success },
        } = response;
        if (success) {
          AdminServerActionCreators.assignDriverSuccess(props);
        } else {
          AdminServerActionCreators.assignDriverFail(props);
        }
      },
      (response) => {
        const {
          entity: { success, error },
        } = response;

        AdminServerActionCreators.assignDriverFail({
          ...props,
          error,
          success,
        });
      },
    );
  },
  getAvailableDriversByMarket(params, options) {
    getAvailableDriversByMarket(params, options).then(
      (response) => {
        AdminServerActionCreators.receiveAvailableDriversSuccess(
          response.entity.data,
        );
      },
      (response) => {
        console.error(response);
      },
    );
  },
  async getDriverNamesByCarrier(carrierId, near = []) {
    return getDriverNamesByCarrier(carrierId, near).then(
      (response) => {
        return response.entity.data;
      },
      (error) => {
        return error.entity;
      },
    );
  },
};

AdminAppDispatcher.register((payload) => {
  const driverId = payload.action.driverId;
  const offerId = payload.action.offerId;
  switch (payload.action.type) {
    case Actions.ASSIGN_DRIVER_REQUEST:
      Utils.acceptOffer({ driverId, offerId });
      break;
    default:
  }
});

export default Utils;
